// Func = limiting Scope for this file
var lastScrollTop = 0;
(function(){

	$(document).ready(function () {


		$('.list-item-sym').slick();
		$('.sym-slides').slick();

				//Properties Day's Calendar [Enable/Disable,ClassName,Tooltip]
				let DATE_STYLE = [true];
				function calendarRange(date){
					let d1=$.datepicker.parseDate(DATE_FORMAT,$('#CheckIn').val());
					let d2=$.datepicker.parseDate(DATE_FORMAT,$('#CheckOut').val());
					if (d1 && date.getTime() == d1.getTime() || d2 && date.getTime() == d2.getTime()) {
						DATE_STYLE[1] = 'highlight-top';
					}else if(date > d1 && date < d2){
						DATE_STYLE[1] = 'highlight';
					}else{
						DATE_STYLE[1] = '';
					}
					return DATE_STYLE;
				}
		
				$('.js-open-booking').on('click', function(e){		
					$(".booking-widget-inline-date, .booking-widget-inline-date .form-entry.notice, .booking-widget-inline-date .close").animate({ right: "0"} , 500);
					$("#pickup").trigger("click");
					$("#nights").val("0 Nights");
					$("#adults").val(1);
					$("#child").val(0);
					$("#number_guest").text( "1 ADULT" );
					$("body").addClass("stop-scrolling-page");
						e.preventDefault();
				});
		
				//Check in and check out datepicker for booking engine
				const DATE_FORMAT = ($("#CheckIn").data("format") !== undefined && $("#CheckIn").data("format")) ? $("#CheckIn").data("format") : "yy-mm-dd";
				$( "#CheckIn" ).datepicker({
					//showOn: "both",
					//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
					//buttonImageOnly: true,
					changeMonth: true,
					dateFormat: DATE_FORMAT,
					numberOfMonths: 1,
					minDate: 0,
					beforeShowDay: (date) => calendarRange(date),
					onSelect: function( selectedDate ) {
						let getDate = $(this).datepicker('getDate');
						let newDate = new Date(getDate.getTime());
						newDate.setDate(newDate.getDate() + 3);
						$( "#CheckOut" ).datepicker( "setDate", newDate );
						$( "#CheckOut" ).datepicker( "option", "minDate", selectedDate );
					}
				});
				$( "#CheckOut" ).datepicker({
					//showOn: "both",
					//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
					//buttonImageOnly: true,
					dateFormat: DATE_FORMAT,
					changeMonth: true,
					numberOfMonths: 1,
					beforeShowDay: (date) => calendarRange(date),
					onSelect: function( selectedDate ) {
						//$( "#CheckIn" ).datepicker( "option", "maxDate", selectedDate );
					}
				});
		

	

		// 	main menu
		var burger = $('#header .burger').on('click',function(){
			
		$(this).parent().toggleClass('open');
		
		
			if($('#header .main-menu').hasClass('open')){	
				var button_burger = burger.find('span').text();
						burger.find('span').text("CLOSE");
				
				if($('body#home').length > 0){
						$('.box-primary-nav-adventure').css({
						'top': heightHeader,
						'height': heightHeaderImageHome
					});
					if($("#booking-container").hasClass('open')){
						
						$("#booking-container").removeClass('open');
						var button_text = booking_btn.find('span').text();
						booking_btn.find('span').text(button_text == "Book Now" ? "X CLOSE" : "Book Now");
					}
				}else{
					$('.box-primary-nav-adventure').css({
						'top': heightHeader,
						'height': '630px'
					});
					if($("#booking-container").hasClass('open')){
						$("#booking-container").removeClass('open');
						var button_text = booking_btn.find('span').text();
						booking_btn.find('span').text(button_text == "Book Now" ? "X CLOSE" : "Book Now");
					}
				}
			}else{
			var button_burger = burger.find('span').text();
					burger.find('span').text("menu");
		
			$('.box-primary-nav-adventure').css({
				'top': heightHeader,
				'height': '0px'
			});
			}
		
		});

		/*MOBILE MENU NAV
	****************************************************************/
		
		//Open Navigation
		$('#menu-btn').on('click',function(){
			$('html').addClass('hide-overflow');
			$('.navigation').addClass('open');
			$('.navigation').stop().animate({top:'0px'},{duration:300});
			if($('.navigation ul li a').hasClass('.item-open')){
				$(".item-open").get(0).scrollIntoView(false);
			}
		});

		$('.close-menu').on('click',function(){
			//event.preventDefault();
			$('html').removeClass('hide-overflow');
			$('.navigation').removeClass('open');
			$('.navigation').stop().animate({top:'100%'},{queue:false,duration:300});
		});
	
	// $("#booking-trigger").click(function (e) {
    //     if(!$(this).hasClass("burger-open")){
    //         e.preventDefault();
    //     }
    //     var button_text = booking_btn.find('span').text();
    //     booking_btn.find('span').text(button_text == "Book Now" ? "X CLOSE" : "Book Now");
    //     $(this).toggleClass("open");
    //     $("#booking-container").toggleClass("open");
    //     $('#header .main-menu').removeClass('open');
    //     $('.box-primary-nav-adventure').css({
	// 		'top': heightHeader,
	// 		'height': '0px'
	// 	});
    // });

		// Main Nav Dropdown
		$("#primary-nav li").hover(function(){
			$(this).addClass("hover");
			$('ul.submenu',this).fadeIn(200);
		}, function(){
			$(this).removeClass("hover");
			$('ul.submenu',this).fadeOut(200);
		});

		




		// Map: Return to previous page button. Change body id to match map template's name.
		//$('body#map-category-sidebar #content').prepend('<a class="btn return-from-map" href="javascript:history.back()">« Back to previous page</a>');
		
	});

	window.onload = function() {
		$('#content .btn').wrapInner('<span></span>');
	

		/*this function add a class to header when scroll down the page
		/* and change the logo by a new file if needed depending of mockup
		*/

		// scrollDownAction(20, 'scroll');

		scrollW();
		window.addEventListener('scroll', function(){
			scrollW();
		})
	};

}());

function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 80){
		if (st > lastScrollTop){
			// downscroll code
			if(!document.getElementById('header').classList.contains('down')){
				document.getElementById('header').classList.add('down');
				document.getElementById('header').classList.remove('up');
			//	document.getElementsByClassName('header__logo')[0].classList.add('hidden');
			//	document.getElementsByClassName('logo-color')[0].classList.remove('hidden');
			}
		} else {
			// upscroll code
			if(!document.getElementById('header').classList.contains('up')){
				document.getElementById('header').classList.add('up');
				document.getElementById('header').classList.remove('down');
			}
		}
	} else {
		if(document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')){
			document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('down');
		//	document.getElementsByClassName('header__logo')[0].classList.remove('hidden');
		//	document.getElementsByClassName('logo-color')[0].classList.add('hidden');
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling

	const window_height = window.innerHeight;
	let animatedEl = document.getElementsByClassName('animate-fade-2');
	for (let i = 0; i < animatedEl.length; i++) {
		var viewportOffset = animatedEl[i].getBoundingClientRect();
		let topPos = viewportOffset.top;
		if(topPos <= window_height*0.8){
			animatedEl[i].classList.add('fade-in');
		}
	}
}

	//Acts when scroll down page.
	// $(window).scroll(function (event) {
	// 	scrollDown();
	// });

//Call function with browser is resized.
$(window).resize(function (event) {
	//resizeWindow();
});
//resizeWindow();